import React from "react";

const TextWithLineBreaks = ({ text }) => {
  const formattedText = text.replace(/(?:\r\n|\r|\n)/g, "<br />");
  return <div dangerouslySetInnerHTML={{ __html: formattedText }} />;
};

export default TextWithLineBreaks;
